import { ChangeDetectionStrategy, Component, TrackByFunction } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TariffService } from '../../../core/services/tariff.service';
import { UtilsService } from '../../../core/services/utils.service';
import { ConnectionType, ConnectionTypeFullName, Tariff } from '../tariff.model';
import { tariffsSubmenu } from '../tariffs-submenu';

type TariffsByType = Record<ConnectionType, {
  title: ConnectionTypeFullName;
  tariffs: Tariff[];
}>;

@Component({
  selector: 'tax-tariffs',
  templateUrl: './tariffs-page.component.html',
  styleUrls: ['./tariffs-page.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TariffsPageComponent {
  readonly tabs = tariffsSubmenu;
  readonly tariffsByTypes$: Observable<TariffsByType> = this.tariffService.getPublicTariffsByParams({
    kkmModel: '',
    kkmSerial: '',
  })
    .pipe(
      map(tariffs => this.combineTariffsByConnectionType(tariffs)),
    );

  readonly trackById: TrackByFunction<Tariff> = this.utilService.trackById;

  constructor(
    private tariffService: TariffService,
    private utilService: UtilsService,
  ) {}

  private combineTariffsByConnectionType(tariffs: Tariff[]): TariffsByType {
    const tariffsByTypes: TariffsByType = {
      WIRED: {
        title: ConnectionTypeFullName.WIRED,
        tariffs: [],
      },
      WIRELESS: {
        title: ConnectionTypeFullName.WIRELESS,
        tariffs: [],
      },
    };

    return tariffs.reduce((accumulator: TariffsByType, tariff: Tariff) => {
      if (tariff.connectionType.connection) {
        accumulator[tariff.connectionType.connection].tariffs.push(tariff);
      }
      return accumulator;
    }, tariffsByTypes);
  }
}
